module.exports = __webpack_public_path__ + "img/Hero.0d80d3c1.png";